import { render, staticRenderFns } from "./wy-advSentiment-trend.vue?vue&type=template&id=0fc5a564&"
import script from "./wy-advSentiment-trend.vue?vue&type=script&lang=js&"
export * from "./wy-advSentiment-trend.vue?vue&type=script&lang=js&"
import style0 from "./wy-advSentiment-trend.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports